import BaseApiService from './BaseApiService.js';

class ReportCardTemplateService extends BaseApiService {
  async getTemplatesByOrg(orgId) {
    return this.makeRequest(`/api/report-card-templates/organization/${orgId}`);
  }

  async saveTemplate(templateData) {
    return this.makeRequest('/api/report-card-templates', {
      method: 'POST',
      body: JSON.stringify(templateData)
    });
  }

  async duplicateTemplate(id, orgId) {
    return this.makeRequest(`/api/report-card-templates/${id}/duplicate?orgId=${encodeURIComponent(orgId)}`, {
      method: 'POST'
    });
  }

  async setDefaultTemplate(id, orgId) {
    return this.makeRequest(`/api/report-card-templates/${id}/set-default?orgId=${encodeURIComponent(orgId)}`, {
      method: 'POST'
    });
  }

  async deleteTemplate(id, orgId) {
    return this.makeRequest(`/api/report-card-templates/${id}?orgId=${encodeURIComponent(orgId)}`, {
      method: 'DELETE'
    });
  }

  async getAssignments(orgId) {
    return this.makeRequest(`/api/report-card-templates/assignments/organization/${orgId}`);
  }

  async saveAssignments(orgId, assignmentsList) {
    return this.makeRequest(`/api/report-card-templates/assignments/organization/${orgId}`, {
      method: 'POST',
      body: JSON.stringify(assignmentsList)
    });
  }

  async resolveTemplate(orgId, academicYear, className) {
    const query = new URLSearchParams({ orgId, academicYear, className }).toString();
    return this.makeRequest(`/api/report-card-templates/resolve?${query}`);
  }
}

const reportCardTemplateServiceInstance = new ReportCardTemplateService();
export default reportCardTemplateServiceInstance;
